// extracted by mini-css-extract-plugin
export default {"line":"BiometricDetails_line__+I2PG","notes":"BiometricDetails_notes__PK7fE"};